import { withUiFilterKeyAliases } from "../../Utils/filterKeyAliases";

export const processBondData = (data) => {
    // The stored JSON carries the backend spelling (minCoupon, ...); everything downstream
    // of this flatten — chips, view inventory, add order — reads the UI spelling
    // (couponMin, ...), so expose both
    const parsed = withUiFilterKeyAliases(JSON.parse(data.characteristics));
    const flattened = { ...data, ...parsed };
    delete flattened.characteristics;
    return { ...flattened, bondType: data.type };
  };

export const getActiveData = (mainTab, activeTab, stagingOrderData, orderData, bondCharData, bondLadderData) => {
  if (mainTab === 0) {
    // Staging Blotter view with sub-tabs
    if (activeTab === 0) {
      // Show staging orders directly from the API
      return stagingOrderData;
    } else if (activeTab === 1) {
      return bondCharData;
    } else {
      return bondLadderData;
    }
  } else {
    // Orders view - show all order data from the orders API
    return orderData;
  }
};